import { render, staticRenderFns } from "./OpportunityDetails.vue?vue&type=template&id=0b31cf30&"
import script from "./OpportunityDetails.vue?vue&type=script&lang=js&"
export * from "./OpportunityDetails.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports